module.exports = __webpack_public_path__ + "media/theme/favicon-5d503123.png";